import { withCompInfo } from '@wix/editor-elements-integrations'
import { ResponsivePopupPageCSSVars, ResponsivePopupPageDefinition } from './ResponsivePopupPage'

// Delete this file once specs.thunderbolt.compCssMappers_catharsis is merged because
// there is no structure mapper in catharsis and this flow is handled in Page.mapper.ts
export const css = withCompInfo<ResponsivePopupPageCSSVars, ResponsivePopupPageDefinition>()([], () => ({
	width: '100%',
	height: 'auto',
}))
